import { Input, Form, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import '../SurveyAnswer.less';

// 矩阵填空 - (h5、pc)
const MatrixBlanks: React.FC = ({ formValue, body, required = true, id, optionList, notValitator, num, form }: { formValue?: any; body?: string; required?: boolean; optionList?: Array<string>; num?: number; id?: number; form?: any; notValitator?: any }) => {
    const [isShowTip, setIsShowTip] = useState(false);
    const [cols, setCols] = useState([]);
    const [rows, setRows] = useState([]);

    const scrollFun = (e: any) => {
        let doc = document.getElementsByClassName('table-container')[0];
        let leftFixs: any = doc.getElementsByClassName('fixed');
        if (e.target.scrollLeft > 0) {
            [...leftFixs].forEach(item => {
                item.classList.add('box-shadow');
            });
        } else {
            [...leftFixs].forEach(item => {
                item.classList.remove('box-shadow');
            });
        }
    };

    useEffect(() => {
        if (optionList && optionList.length) {
            let option: any = optionList[0];
            if (option.content) {
                let arr = JSON.parse(option.content);

                setRows(arr[0]);
                setCols(arr[1]);
            }
        }
    }, [optionList]);

    // 实时监听输入值变化校验
    useEffect(() => {
        if (formValue && required) {
            let value = formValue[`${id}-10`];
            if (value && value.length && optionList && optionList.length) {
                let row, col;
                let isExist = false;
                let option: any = optionList[0];
                if (option.content) {
                    let arr = JSON.parse(option.content);
                    row = arr[0].length;
                    col = arr[1].length;
                    for (let i = 0; i < col; i++) {
                        let res = value.slice(i * row, (i + 1) * row).every((it: any) => it);
                        if (res) {
                            isExist = true;
                            break;
                        }
                    }
                }
                if (isExist) {
                    setIsShowTip(false);
                } else {
                    setIsShowTip(true);
                }
            }
        }
        // if (formValue && !required) {
        //     let value = formValue[`${id}-10`];
        //     if (value && value.length) {
        //         let isInput = value.filter((it: any) => !it);
        //         let isExistInput = value.filter((it: any) => it);
        //         if (isExistInput && isExistInput.length && isInput && isInput.length) {
        //             setIsShowTip(true);
        //         } else {
        //             setIsShowTip(false);
        //         };
        //     };
        // };
    }, [formValue]);

    // 提交校验是否必填
    useEffect(() => {
        if (notValitator?.indexOf(id) !== -1) {
            setIsShowTip(true);
        } else {
            setIsShowTip(false);
        }
    }, [notValitator]);

    useEffect(() => {
        let doc: any = document.getElementsByClassName('table-container')[0];
        if (doc) {
            doc.addEventListener('scroll', scrollFun, true);
        }
        return () => {
            if (doc) {
                doc.removeEventListener('scroll', scrollFun, true);
            }
        };
    }, []);

    return (
        <div className={`${isShowTip ? 'ant-form-item-has-error' : null}`}>
            <Form.Item
                // name={[`${id}-10`, cols.length * rows.length]}
                rules={[{ required, message: '该题为必答题，请作答后提交。' }]}
                label={<div className={`${required ? 'show-required' : null}`} style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}
            >
                {window.innerWidth <= 750 ? (
                    cols && cols.length ? (
                        cols.map((col: string, colIndex: number) => (
                            <div className="matrix-item" key={colIndex}>
                                <p className="matrix-item_col">{col}</p>
                                {rows && rows.length
                                    ? rows.map((row: string, rowIndex: number) => (
                                          <Form.Item
                                              name={[`${id}-10`, colIndex * rows.length + rowIndex]}
                                              // rules={[{ required, message: '' }]}
                                              label={row}
                                              key={rowIndex}
                                          >
                                              <Input maxLength={200} placeholder="请输入" />
                                          </Form.Item>
                                      ))
                                    : null}
                            </div>
                        ))
                    ) : null
                ) : (
                    <div className="matrix-pc">
                        <div className="table-container">
                            <table>
                                <thead>
                                    <tr className="top-title">
                                        <td className="fixed top"></td>
                                        {rows && rows.length ? rows.map((row: any, rowIndex: number) => <td key={rowIndex}>{row}</td>) : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {cols && cols.length
                                        ? cols.map((col: string, colIndex: number) => (
                                              <tr key={colIndex}>
                                                  <td className="fixed">{col}</td>
                                                  {rows && rows.length
                                                      ? rows.map((row: string, rowIndex: number) => (
                                                            <td key={rowIndex}>
                                                                <Form.Item
                                                                    // rules={[{ required, message: '' }]}
                                                                    name={[`${id}-10`, colIndex * rows.length + rowIndex]}
                                                                    label=""
                                                                >
                                                                    <Input maxLength={200} placeholder="请输入" />
                                                                </Form.Item>
                                                            </td>
                                                        ))
                                                      : null}
                                              </tr>
                                          ))
                                        : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
                {isShowTip ? <p style={{ color: '#ff4d4f' }}>{required ? '该题为必答题，请作答后提交。' : '请填写完成'}</p> : null}
            </Form.Item>
        </div>
    );
};

export default MatrixBlanks;
